<template>
  <div v-if="datalist.length > 0">
    <div class="gl_listWrapBar" v-for="(item, index) in datalist" :key="index">
      <a href="javascript:;" class="gl_listItem">
        <div class="gl_listItemTitle gl_ltStyle_line" @click="tojourdetail(item)">[{{ item.nian }}年{{ item.qi }}期] {{
          ellipsis(textFormat(item.biaoTi_CN), 60) }}</div>
        <div class="gl_listItemSub" @click="tojourdetail(item)">
          {{ ellipsis(textFormat(item.zhaiYao_CN), 60) }}
        </div>
        <div class="display_between marginTop10">
          <div>
            <span class="fontBold">关键词：</span>
            <span class="gl_gree_block" v-for="(itemn, indexn) in (item.guanJianCi_CN || '').split('；')" :key="indexn"
              @click="onsearch(filterHtml(itemn))">{{ filterHtml(itemn) }}</span>
          </div>
          <div class="gl_inforshow">
            <span class="marginRight20">{{ formatTime(item.chuBanRiQi, 'YYYY/MM/DD') }}</span>
            <!-- <span><img src="/image/index/chakan.png">{{item.seeNum}}</span> -->
          </div>
        </div>
      </a>
    </div>
  </div>
  <div v-else-if="ishow">暂无数据</div>
</template>

<script>
import format from '@/assets/unit/unit.js';
export default {
  name: 'ShLiteList',
  props: {
    datalist: {
      type: Array
    },
    ishow: {
      type: Boolean
      // default: false,
    }
  },
  data() {
    return {
      apiData: []
    };
  },
  created() { },
  methods: {
    onsearch(keywords) {
      const { href } = this.$router.resolve({
        path: '/home/searchPage?',
        query: {
          labelname: keywords,
          tagIndexmuber: 'ShLiteList'
        }
      });
      window.open(href, '_blank');
    },
    /**文献跳转详情 */
    tojourdetail(item) {
      const { href } = this.$router.resolve({
        path: '/journal/magazinejournal/magazinejournaldetail',
        query: {
          nian: item.nian,
          qi: item.qi,
          id: item.id
        }
      });
      // alert(href)
      window.open(this.httphelper.IsDebugGP519() + href, '_blank');
    },
    filterHtml(value) {
      return value
        .replace(/<[^>]+>/g, '')
        .replace(/\s+/g, '')
        .replace(/&emsp;/g, '');
    },
    formatTime(datatime, timeformat) {
      return format(datatime, timeformat);
    },
    textFormat(val) {
      return val
        .replace(/<[^>]+>/g, '')
        .replace(/&mdash;/g, '')
        .replace(/&ldquo;/g, '')
        .replace(/&rdquo;/g, '')
        .replace(/&gamma;/g, '')
        .replace(/&beta;/g, '')
        .replace(/#br#/g, '')
        .replace(/&quot;/g, '')
        .replace(/&kappa;/g, '')
        .replace(/&nbsp;/g, '');
    }
  }
};
</script>

<style scoped></style>
